// import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";

const Contact = () => {
  const formInitialDetails = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  }
  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [buttonText, setButtonText] = useState('Send');
  const [status, setStatus] = useState({});

  const [formErrors, setFormErrors] = useState({});
  // const [isSubmit, setIsSubmit] = useState(false);

  const onFormUpdate = (category, value) => {
    setFormDetails({...formDetails,[category]: value})
  }

  const handleSubmit = async (e) => {
    //  console.log(JSON.stringify(formDetails));
    e.preventDefault();
    setFormErrors(validate(formDetails));


    console.log(formErrors);
    // if(formErrors){
    //   alert("success");
    //   setButtonText("Sending...");
    // }


      setButtonText("Sending...");
      let response = await fetch("http://localhost:5000/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify(formDetails),
      });

      setButtonText("Send");
      let result = await response.json();
      setFormDetails(formInitialDetails);

      if (result.code == 200) 
      {
        setStatus({ succes: true, message: 'Message sent successfully'});
      } 
      else 
      {
        setStatus({ succes: false, message: 'Something went wrong, please try again later.'});
      } 
    // }

  };
  
  const validate = (values) => {
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    const regexphone = /^[0]?[789]\d{9}$/;

    if (!values.firstName) {
      errors.firstName = "Username is required!";
    }

    if (!values.email) {
      errors.email = "Email is required!";
    } else if (!regex.test(values.email)) {
      errors.email = "This is not a valid email format!";
    }

    if (!values.phone) {
      errors.phone = "Phone Number is required";
    } else if (!regexphone.test(values.phone)) {
      errors.phone = "Enter a valid 10 Digits Phone Number";
    }else if (values.phone.length < 10) {
      errors.phone = "Enter a valid 10 Digits Phone Number";
    } else if (values.phone.length > 10) {
      errors.phone = "Enter a valid 10 Digits Phone Number";
    }
    return errors;
  };

  return (
    <section className="contact" id="contact">
      <Container>
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <iframe className="map" src="https://maps.google.com/maps?width=720&amp;height=450&amp;hl=en&amp;q=nayapalli bhubaneswar&amp;t=&amp;z=11&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe>
          </Col>
          <Col size={12} md={6}>
            <h2>Get In Touch</h2>
            <form onSubmit={handleSubmit}>
              <Row>
                <Col size={12} sm={6} className="px-1">
                  <input type="text" value={formDetails.firstName} placeholder="First Name" onChange={(e) => onFormUpdate('firstName', e.target.value)} />
                  <p>{formErrors.firstName}</p>
                </Col>
                <Col size={12} sm={6} className="px-1">
                  <input type="text" value={formDetails.lastName} placeholder="Last Name" onChange={(e) => onFormUpdate('lastName', e.target.value)}/>
                </Col>
                <Col size={12} sm={6} className="px-1">
                  <input type="email" value={formDetails.email} placeholder="Email Address" onChange={(e) => onFormUpdate('email', e.target.value)} />
                  <p>{formErrors.email}</p>
                </Col>
                <Col size={12} sm={6} className="px-1">
                  <input type="tel" value={formDetails.phone} placeholder="Phone No." onChange={(e) => onFormUpdate('phone', e.target.value)}/>
                  <p>{formErrors.phone}</p>
                </Col>
                <Col size={12} className="px-1">
                  <textarea rows="6" value={formDetails.message} placeholder="Message" onChange={(e) => onFormUpdate('message', e.target.value)}></textarea>
                  <button type="submit"><span>{buttonText}</span></button>
                </Col>
                {
                  status.message &&
                  <Col>
                    <p className={status.success === false ? "danger" : "success"}>{status.message}</p>
                  </Col>
                }
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
export default Contact